import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";

import { ApplicationsActions, selectCurrentApplicationId } from "@redux";
import { i18, trb } from "@utilities";

export const ApproveBeneficiaresModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    modal.confirm({
      title: trb(i18.ApplicationsLabels.AreYouSure),
      content: trb(i18.Buttons.ApproveBeneficiaries),
      okText: trb(i18.Buttons.Ok),
      cancelText: trb(i18.Buttons.Cancel),
      onCancel: onClose,
      onOk: async () => await handleOk()
    });
  }, []);

  const handleOk = async () => {
    await dispatch(
      ApplicationsActions.approveBeneficiaries(appId, i18.NotificationTitles.SuccessOperation)
    );
    onClose();
  };

  return contextHolder;
};
